import { Pipe, PipeTransform } from '@angular/core';
import { isArray, isString } from 'lodash';

@Pipe({
    name: 'formatcc',
    standalone: true
})
export class FormatCcPipe implements PipeTransform {
    /**
     *
     * @param value
     * @returns {number}
     */
    transform(value): string {
        if (isArray(value)) {
            return value.join(', ');
        }

        return value;
    }
}